import React, { SVGProps } from 'react'

export const CustomArrowFilled = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width={12}
			height={12}
			viewBox="0 0 12 12"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path d="m5.75 9.25-5-6.5h10z" fill="currentColor" />
		</svg>
	)
}
